<template name="component-name">
  <div>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">

    <md-dialog :md-active.sync="show">
      <md-dialog-content>
        <social-sharing
          :url="page"
          :title="title"
          :description="synopsis"
          :quote="synopsis"
          hashtags="chapstory"
          inline-template
        >
          <div class="networkList">
            <network class="socialMedia socialEmail" network="email">
              <i class="fa fa-envelope"></i>
              <span> Email</span>
            </network>
            <network class="socialMedia socialFacebook" network="facebook">
              <i class="fa fa-facebook"></i>
              <span> Facebook</span>
            </network>
            <network class="socialMedia socialReddit" network="reddit">
              <i class="fa fa-reddit-alien"></i>
              <span> Reddit</span>
            </network>
            <network class="socialMedia socialTelegram" network="telegram">
              <i class="fa fa-telegram"></i>
              <span> Telegram</span>
            </network>
            <network class="socialMedia socialTwitter" network="twitter">
              <i class="fa fa-twitter"></i>
              <span> Twitter</span>
            </network>
            <network class="socialMedia socialVk" network="vk">
              <i class="fa fa-vk"></i>
              <span> VKontakte</span>
            </network>
            <network class="socialMedia socialWhatsapp" network="whatsapp">
              <i class="fa fa-whatsapp"></i>
              <span> Whatsapp</span>
            </network>
          </div>
        </social-sharing>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button style="background: lightgrey;" @click="show = false">
          Cancelar
        </md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
export default {
  props: ["share", "title", "content"],
  computed: {
    show: {
      get() {
        return this.share;
      },
      set(val) {
        this.$emit("close", val)
      }
    },
    synopsis() {
      if (this.content && this.content.length > 100)
        return this.content.slice(0, 100) + "...";
      else
        return this.content;
    },
    page() {
      return this.$route.isProduction? location.href : "https://chapstory.com" + location.pathname;
    }
  },
}
</script>

<style>
span.socialMedia {
  color: white;
}

.socialMedia {
  margin-right: 1em;
  margin-bottom: 5px;
  padding: 3px 8px 2px;
  border-radius: 8px;
  width: fit-content;
  display: inline-block;
}

.socialMedia:hover {
  cursor: pointer;
  filter: brightness(0.9);
}

.socialShare {
  display: inline-block;
  width: 1em;
  height: 1em;
  vertical-align: top;
}

.socialEmail {
  background-color: #777;
}

.socialFacebook {
  background-color: #3b5998;
}

.socialReddit {
  background-color: #5f99cf;
}

.socialTelegram {
  background-color: #54a9eb;
}

.socialTwitter {
  background-color: #55acee;
}

.socialVk {
  background-color: #507299;
}

.socialWhatsapp {
  background-color: #25d366;
}

@media (max-width: 600px) {
  .networkList {
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
  }
}


</style>
